import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { createTwilioCampaign } from 'api/admin/businesses/twilioIntegration';
import { CreateTwilioCampaignRequestPayload } from 'types/twilio/twilioCampaign';

interface useCreateTwilioCampaignPayload {
  successCallback?: () => void;
}

export const useCreateTwilioCampaign = ({
  successCallback,
}: useCreateTwilioCampaignPayload) => {
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    CreateTwilioCampaignRequestPayload
  >({
    mutationFn: async ({ businessId, data }) => {
      return createTwilioCampaign({ businessId, data });
    },
    onSuccess: async () => {
      successCallback?.();

      toaster('Campaign has been created', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while creating campaign', {
        icon: '❌',
      });
    },
  });
};
